// extracted by mini-css-extract-plugin
export default {"productGrid":"ZY-z","centerLink":"_Y-z","productSection":"aZ-z","item":"bZ-z","ctaButton":"cZ-z"};